import { ButtonType, ButtonWidget, FlyoutListMenuWidget, MenuButtonWidget, SplitButtonWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';

interface AddNewIpButtonProps {
    onAddIp: () => void;
    onBulkEdit: () => void;
    disabled?: boolean;
}

interface DropDownMenuButtonProps {
    'aria-label': string;
    onBulkEdit: () => void;
    disabled?: boolean;
}

function DropDownMenuButton(props: DropDownMenuButtonProps) {
    const [isOpen, setOpen] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
    const menuId = 'ip-allowlist-dropdown-menu-id';

    const handleSelect = React.useCallback((value: string) => {
        if (value === 'bulk-editor') {
            props.onBulkEdit();
        }
        setOpen(false);
    }, [props]);

    const { onBulkEdit, ...menuProps } = props;

    return <>
        <MenuButtonWidget
            aria-controls={menuId}
            isOpen={isOpen}
            onClick={() => setOpen(!isOpen)}
            ref={setAnchorEl}
            testId='ip-allowlist-dropdown-menu-button'
            {...menuProps}
        />
        {isOpen &&
            <FlyoutListMenuWidget
                anchorEl={anchorEl!}
                allowAutoPosition
                id={menuId}
                menuItemInfos={[
                    { displayValue: Messages.ipAllowlistBulkEditDialogButton(), value: 'bulk-editor' }
                ]}
                onSelect={handleSelect}
                requestCloseAll={() => setOpen(false)}
                menuStyle={{ minWidth: anchorEl!.getBoundingClientRect().width }}
                subMenuAllowAutoPosition
                testId='ip-allowlist-dropdown-bulk-editor'
                toggleEl={anchorEl!}
            />
        }
    </>;
}

export function AddNewIpButton(props: AddNewIpButtonProps) {
    return (
        <div>
            <SplitButtonWidget
                button={<ButtonWidget
                    buttonType={ButtonType.Primary}
                    testId='ip-allowlist-add-ip-button'
                    onClick={props.onAddIp}
                    disabled={props.disabled}
                >
                    {Messages.ipAllowlistAddIpAddress()}
                </ButtonWidget>}
                menuButton={<DropDownMenuButton aria-label="IP Allowlist Menu" onBulkEdit={props.onBulkEdit} disabled={props.disabled} />}
            />
        </div>
    );
}
